import React from 'react';
import { Spinner } from 'react-bootstrap';
import { UserListData } from './hooks';
import Card from '../../../components/molecules/cards';

interface Props {
    listUser: UserListData[];
    isLoading: boolean;
    // eslint-disable-next-line no-unused-vars
    onNavigate: (id: string) => void;
    step: number;
}

function RenderUserList(props: Props) {
  const {
    listUser, isLoading, onNavigate, step,
  } = props;
  if (isLoading) {
    return (
      <div className="flexible-center">
        <Spinner animation="border" className="fz-14" />
      </div>
    );
  }
  if (listUser && listUser.length) {
    return (
      <div className="row">
        {listUser.map((user) => (
          <div key={user.id} className="col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-2">
            <Card.User
              id={user.id.toString()}
              name={user.name}
              email={user.email}
              role={user.position}
              borderColor={step === 0 ? 'stroke' : 'red'}
              onClick={() => onNavigate(user.id)}
            />
          </div>
        ))}
      </div>
    );
  }
  return <div className="text-center w-100">Data Not Found</div>;
}

export default RenderUserList;
